export default function LearnTab() {
  let learnData = ['learn', 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div className="text-center text-faded text-3xl font-hind p-20">
      Coming Soon...
    </div>
  );
}
